// extracted by mini-css-extract-plugin
export default {"root":"Count-root-496dec0cc4cc4c5ab9302c40048ec2fe"};